







































import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import VoteList from '../components/VoteList.vue';
import { mainMessage } from '../api';
@Component({
  components: {
    SearchBar,
    VoteList,
  },
})
export default class Home extends Vue {
  AllNum = 0;
  AllPeople = 0;
  AllView = 0;
  activeType = '1';
  tab = [
    { text: '投票', id: '1' },
    { text: '排行', id: '2' },
  ];

  search = '';

  changeTab(item: any) {
    this.activeType = item.id;
  }
  async created() {
    const res = await mainMessage();
    this.AllNum = res.data.AllNum;
    this.AllPeople = res.data.AllPeople;
    this.AllView = res.data.AllView;
  }
}
